var _style, _filter, _g, _defs, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 60",
    style: {
      enableBackground: "new 0 0 180 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{clip-path:url(#SVGID_00000080190031406147547480000008909292255635617713_);}\n\t.st3{filter:url(#drop-shadow-4);}\n\t.st4{fill:#F2F2F2;}\n\t.st5{fill:#D7CCFF;}\n\t.st6{fill:#6BDD6A;}\n\t.st7{fill:#B198F8;}\n")), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    filterUnits: "userSpaceOnUse",
    id: "drop-shadow-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#250051",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    operator: "over"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.5,52.5c-11.4,0.6-15-7.3-32.9-4c-14.3,2.6-20.4-7.1-22.2-13.2c-0.9-2.9-1.1-14.2,6.8-14.4 C65.8,20.3,87.1-9,99.9,16.7C105.1,27.1,113.3,51.2,87.5,52.5z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -1,
    y: -1,
    width: 182,
    height: 62
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016773698779775832450000001002013441410220425_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000016773698779775832450000001002013441410220425_)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78.2,18.3L92.4,4.1c0.4-0.4,0.9-0.3,1.3,0l17.1,17.2c0.4,0.4,0.3,0.9,0,1.3L96.6,36.8 c-0.4,0.4-0.9,0.3-1.3,0L78.2,19.6C77.8,19.2,77.8,18.7,78.2,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M89.4,26.9l11.7-11.6c0.2-0.2,0.6-0.2,0.8,0l0,0c0.2,0.2,0.2,0.6,0,0.8L90.3,27.8c-0.2,0.2-0.6,0.2-0.8,0 l0,0C89.2,27.5,89.2,27.1,89.4,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M87.4,25l11.7-11.6c0.2-0.2,0.6-0.2,0.8,0l0,0c0.2,0.2,0.2,0.6,0,0.8L88.3,25.9c-0.2,0.2-0.6,0.2-0.8,0l0,0 C87.2,25.6,87.2,25.2,87.4,25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M85.5,17.6l6.3-6.3c0.2-0.2,0.6-0.2,0.8,0v0c0.2,0.2,0.2,0.6,0,0.8l-6.3,6.3c-0.2,0.2-0.6,0.2-0.8,0l0,0 C85.3,18.2,85.3,17.9,85.5,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M91.3,28.8L103,17.2c0.2-0.2,0.6-0.2,0.8,0l0,0c0.2,0.2,0.2,0.6,0,0.8L92.1,29.7c-0.2,0.2-0.6,0.2-0.8,0l0,0 C91.1,29.4,91.1,29.1,91.3,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M93,30.6L104.8,19c0.2-0.2,0.6-0.2,0.8,0l0,0c0.2,0.2,0.2,0.6,0,0.8L93.9,31.5c-0.2,0.2-0.6,0.2-0.8,0l0,0 C92.8,31.2,92.8,30.9,93,30.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M94.9,32.6L106.6,21c0.2-0.2,0.6-0.2,0.8,0l0,0c0.2,0.2,0.2,0.6,0,0.8L95.7,33.5c-0.2,0.2-0.6,0.2-0.8,0l0,0 C94.6,33.2,94.6,32.8,94.9,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M100,33.2c0.6-0.6,1.7-1.4,0.7-3.3L97,23.1c-0.2-0.4-0.2-0.9,0.2-1.2s1.2-0.2,1.5,0.3l3.3,6 c0.1,0.2,0.4,0,0.3-0.1c0,0,0-0.2-0.1-0.3l-3.4-7.1c-0.2-0.5,0-1.1,0.5-1.4l0,0c0.5-0.3,1.2,0,1.4,0.5c1,2,3.5,7.1,3.4,7.1 c0-0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.4,0.4,0.3-0.2l-2.7-6.9c-0.2-0.4,0-0.9,0.4-1.1c0.6-0.3,1.2,0,1.5,0.6c0.9,2.3,3.1,7.7,3.1,7.7 l0.2,0.5l0,0c0.2,0.4,0.8,0.2,0.7-0.2l-1.2-5.3c-0.1-0.5,0.2-0.9,0.7-1l0,0c0.5-0.1,0.9,0.2,1,0.7l2,8.8l0.6,2.1 c0.3,0.2,17.3,28.6,17.3,28.6c1.7,2.8,0.7,6.4-2.2,7.9l0,0c-2.8,1.5-6.4,1.6-8.3-2l-12.5-28.5c-0.4-0.9-1.1-1.5-2-1.8L98,35.5"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration1);
export default __webpack_public_path__ + "static/media/illustration1.3154fe36c61f969a589a463fcbb7e891.svg";
export { ForwardRef as ReactComponent };